import React, { useState, useContext, useEffect, startTransition } from "react";

import { AzHeader, AzLogo, AzMainMenu, AzSecondLineMenu, AzLoginButton, AzModalCallback } from "@Development/ui-kit";
import { ApplicationContext } from '@product-site-frontend/shared';
import ConsultationForm from '@product-site-frontend/shared/components/ConsultationForm';

import { NAV_LINKS, NAV_LINKS_EXTENDED_LINE } from "../constants/nav-links";

import popupImage from "../assets/popup.png";
import * as styles from './appBar.module.css';

export default function AppBar() {
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const { setApplicationOpen } = useContext(ApplicationContext);

  const [showModalCallback, setShowModalCallback] = useState(false);
  const [activeSMenuLink, setActiveSMenuLink] = useState(null);

  function handleApplicationButtonClick() {
    setApplicationOpen(true);
  }

  const toggleShowModalCallback = () => {
    startTransition(() => {
      setShowModalCallback(!showModalCallback);
    });
  }

  useEffect(() => {
    let newActiveLink = null;

    NAV_LINKS_EXTENDED_LINE({
      gatsby: process.env.GATSBY_ROOT_URL,
      shop: process.env.GATSBY_SHOP_URL,
      documents: process.env.GATSBY_DOCUMENTS_PUBLIC_URL
    }).forEach((element, id) => {
      if (url === element.link || url === `${element.link}/`) {
        newActiveLink = id;
      }
    });

    setActiveSMenuLink(newActiveLink);
  }, [url]);

  return (
    <AzHeader
      button={(<AzLoginButton
        urls={[
          {
            url: `${process.env.GATSBY_ACCOUNT_URL}/login`,
            text: 'Для клиентов'
          },
          {
              url: `${process.env.GATSBY_PARTNER_URL}/login`,
            text: 'Для партнеров'
          },
          {
            url: `${process.env.GATSBY_AGENT_URL}/login`,
            text: 'Для агентов'
          }
        ]}
      />)}
      className={styles.header}
      fixedWidth={true}
      handleApplicationCallBackClick={toggleShowModalCallback}
      href="/"
      logo={(<AzLogo svg={{ width: 125, height: 36 }} type="basic" />)}
      secondLine={(
        <AzSecondLineMenu
          className={styles[`secondLineActive${activeSMenuLink}`]}
          menu={
            NAV_LINKS_EXTENDED_LINE({
              gatsby: process.env.GATSBY_ROOT_URL,
              shop: process.env.GATSBY_SHOP_URL,
              documents: process.env.GATSBY_DOCUMENTS_PUBLIC_URL
            })
          }
        />
      )}
    >
      <AzMainMenu
        button={(<AzLoginButton
          small={true}
          urls={[
            {
              url: `${process.env.GATSBY_ACCOUNT_URL}/login`,
              text: 'Для клиентов'
            },
            {
            url: `${process.env.GATSBY_PARTNER_URL}/login`,
              text: 'Для партнеров'
            },
            {
              url: `${process.env.GATSBY_AGENT_URL}/login`,
              text: 'Для агентов'
            }
          ]}
        />)}
        className={styles[`mobileLineActive${activeSMenuLink}`]}
        handleApplicationButtonClick={handleApplicationButtonClick}
        handleApplicationCallBackClick={toggleShowModalCallback}
        href="/"
        logo={(<AzLogo svg={{ width: 125, height: 36 }} type="basic" />)}
        menu={
          NAV_LINKS({
            gatsby: process.env.GATSBY_ROOT_URL,
            shop: process.env.GATSBY_SHOP_URL
          })
        }
        mobileMenu={
          NAV_LINKS_EXTENDED_LINE({
            gatsby: process.env.GATSBY_ROOT_URL,
            shop: process.env.GATSBY_SHOP_URL,
            documents: process.env.GATSBY_DOCUMENTS_PUBLIC_URL
          })
        }
      />
      {showModalCallback && (
        <AzModalCallback
          imgSrc={popupImage}
          onClose={toggleShowModalCallback}
        >
          <ConsultationForm />
        </AzModalCallback>
      )}
    </AzHeader>
  );
}
